import { render } from "./popup_change.vue?vue&type=template&id=2add899e"
import script from "./popup_change.vue?vue&type=script&lang=js"
export * from "./popup_change.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__